/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestNoteTakingApps from "views/articles/BestNoteTakingApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"

const AddAppollowToYourHomeScreenEN = ({ apps }: { apps: AppInterface[] }) => {
  const article = BestNoteTakingApps["ar"]
  console.log(apps)

  return (
    <InstantArticle {...article}>
      <div dir="rtl" style={{ textAlign: "justify" }}>
        <p>
          لمساعدتك في تدوين أفضل الملاحظات وإنشاء قوائم مهام مبسطة، قمنا بتجميع
          أفضل تطبيقات تدوين الملاحظات لأجهزة الآيباد استنادًا إلى الأسعار
          والمراجعات والميزات والتوافق حتى تتمكن من كتابة ملاحظاتك بشكل احترافي
        </p>

        <h2>Noteability</h2>
        <p>
          يعد Notability تطبيق ملاحظات يحظى بتقدير كبير ويوفر واجهة بسيطة وقدرات
          قوية. يمكن للمستخدمين إضافة عناصر وسائط متعددة مثل الصوت والفيديو إلى
          ملاحظاتهم ، ويتضمن التطبيق أدوات تنسيق متنوعة. فهو يجمع بين عدة أنواع
          مختلفة من تطبيقات تدوين الملاحظات ويقدم ميزات مثل إنشاء المجلات وأدوات
          الحبر وأدوات التحديد. ومع ذلك ، يتطلب التطبيق اشتراكًا مدفوعًا لعضوية
          Plus ، كما أن أحجام المستندات محدودة.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 360593530)} />
        </div>
        <h2>Microsoft OneNote</h2>
        <p>
          Microsoft OneNote هو تطبيق ملاحظات مجاني. يتم تنظيم الملاحظات بواسطة
          دفاتر الملاحظات والأقسام والصفحات، مع إمكانية إنشاء دفاتر ملاحظات
          فرعية وصفحات فرعية. يمكن للمستخدمين إضافة نصوص وملفات ورسم وتغيير
          أنماط الورق وتسجيل الصوت. يوفر التطبيق أيضًا أداة قلم حساسة للضغط وقلم
          تحديد يمكن تخصيصها بألوان مختلفة، بما في ذلك خيارات اللمعان. بالإضافة
          إلى ذلك، يمكن للمستخدمين حفظ عدد غير محدود من الأقلام وأقلام التحديد
          المفضلة في شريط الأدوات.
        </p>

        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 410395246)} />
        </div>
        <h2>CollaNote</h2>
        <p>
          CollaNote هو تطبيق مجاني لتدوين الملاحظات يقدم مجموعة واسعة من
          الوظائف. يأتي مع قلم كلاسيكي وقلم رصاص وقلم تحديد وأدوات لاسو وممحاة ،
          ويمكن للمستخدمين تخصيص الألوان وحفظ مجموعات الألوان والسمك المفضلة
          لديهم. يشتمل التطبيق أيضًا على مؤشر ليزر ومسطرة قابلة للتعديل وملصقات
          وملاحظات صوتية وقوالب لأنواع الورق ودفتر يوميات رقمي. تتمثل إحدى أكبر
          مزاياها في ميزة التعاون ، مما يسمح بالتعاون في الملاحظات مع الآخرين
          ودمج ملاحظات الجميع.
        </p>

        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1540956268)} />
        </div>
        <h2>Notebook by Zoho</h2>
        <p>
          Notebook هو تطبيق يسمح للمستخدمين بدمج الملاحظات المكتوبة مع الرسوم
          البيانية المرسومة باليد أو الملاحظات المكتوبة بخط اليد. يوفر التطبيق
          تخصيصًا كاملاً لألوان قلم رصاص وقلم وأداة تحديد. كما يوجد ميزات مثل
          قفل ملاحظات محددة ومسح المستندات ضوئيًا للكتابة عليها مباشرة. ومع ذلك
          ، فإن الجانب السلبي في Notebook هو أن الملاحظات المكتوبة بخط اليد يتم
          الاحتفاظ بها منفصلة عن الأنواع الأخرى من الملاحظات ، مما يجعلها أقل
          فائدة لأولئك الذين يرغبون في مزج أنواع مختلفة من الملاحظات في نفس
          الصفحة.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 973801089)} />
        </div>
        <h2>Apple Notes</h2>
        <p>
          تطبيق الملاحظات الافتراضي من Apple هو تطبيق مفيد لتدوين الملاحظات،
          يأتي مع أدوات أساسية مثل القلم وقلم تحديد وقلم رصاص وممحاة وأداة lasso
          ومسطرة قابلة للتعديل. كما يوجد أنماط الورق المختلفة والقدرة على مسح
          المستندات ضوئيًا باستخدام كاميرا الهاتف. يتم الاحتفاظ بالمستندات
          الممسوحة ضوئيًا كمرفقات ولا يمكن تحديدها بالقلم. يسمح التطبيق أيضًا
          بالمزامنة عبر أجهزة متعددة والكتابة بخط اليد باستخدام Apple Pencil.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1110145109)} />
        </div>
        <br />
        <div className="card mt-4 mb-1">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              هل لديك أي تطبيقات أو أدوات مفضلة تستخدمها مع الآيباد الخاص بك؟
              يمكنك مشاركة تطبيقاتك المفضلة من خلال{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  صفحة النشر
                </span>
              </Link>
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenEN
